import { baseService } from "src/store/base.store";
import { executeQuery } from "src/store";
import { Session } from "./types/session.entity";
import { AdministrateSession, FilterSessionsInputs, SessionWithUsers } from "./types";
import { sessionRepository } from "./session.repsoitory";
import { buildSessionsFilter } from "./utils/session-query-builder";
import { userRepository } from "../users/repositories/user.repository";
import { User } from "../users/types/user.entity";
import { callFunctionSafe } from "src/firebase/functions";
// import { Timestamp } from "firebase/firestore";
// sessionRepository.create({
//   type: "DIRECT",
//   bookingIds: [],
//   coachId: "1fy6oiKqUDb52p911210U4lPtuF2",
//   learnerIds: ["3vYRAsgYyARHtfXmxpgJTSP4ZBe2"],
//   coachType: "VOLUNTEER",
//   startTime: Timestamp.now(),
//   isCoachJoined: true,
//   state: "ACTIVE",
//   langCode: "en",
//   missedParticipantIds: [],
//   serviceProviderMeta: {
//     providerName: "AGORA",
//     agoraChannelName: "channelnmae",
//     participants: {},
//   },
//   directCallInitiatorId: "3vYRAsgYyARHtfXmxpgJTSP4ZBe2",
// });
export const withdrawalRequestService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getSessions: builder.query<Session[], { where: FilterSessionsInputs; offset: string }>({
      queryFn: ({ where, offset }) =>
        executeQuery(async () => {
          const safeWhere: FilterSessionsInputs = where ?? ({} as FilterSessionsInputs);
          const filter = await buildSessionsFilter(safeWhere);
          return sessionRepository.find({ where: filter, offset, orderBy: ["startTime", "desc"] });
        }),
    }),
    getSessionById: builder.query<SessionWithUsers, string>({
      queryFn: (id) =>
        executeQuery(async () => {
          const session = await sessionRepository.findById(id);
          if (!session) return null;

          const [coach, learnersRaw] = await Promise.all([
            userRepository.findById(session.coachId),
            Promise.all(Array.from(new Set(session.learnerIds)).map((learnerId) => userRepository.findById(learnerId))),
          ]);

          const usersList = [coach, ...learnersRaw].filter((user) => user !== null);

          const users: SessionWithUsers["users"] = (usersList as User[]).reduce((acc, user) => {
            const role = user.id === coach?.id ? "COACH" : "LEARNER";
            acc[user.id] = {
              id: user.id,
              name: user.name,
              email: user.email,
              pictureURL: user.pictureURL,
              phoneNumber: user.phoneNumber,
              role: role, // matches User["roles"][number]
            };
            return acc;
          }, {} as SessionWithUsers["users"]);

          return { session, users };
        }),
    }),
    countSessions: builder.query<number, { where: FilterSessionsInputs }>({
      queryFn: ({ where }) =>
        executeQuery(async () => {
          const safeWhere: FilterSessionsInputs = where ?? ({} as FilterSessionsInputs);
          const filter = await buildSessionsFilter(safeWhere);
          return filter.id ? 1 : sessionRepository.count(filter);
        }),
    }),
    administrateSession: builder.mutation<void, AdministrateSession>({
      queryFn: (payload) => callFunctionSafe("administrateSession", payload),
    }),
  }),
});

export const { useGetSessionByIdQuery, useGetSessionsQuery, useCountSessionsQuery, useAdministrateSessionMutation } =
  withdrawalRequestService;
